import { createApp } from 'vue'
import router from '@/router/index.js'
import App from './App.vue'
import './styles/common.scss';
import Vant from 'vant';
import 'vant/lib/index.css';
import pu from '@/utils/public-utils'
import { Lazyload } from 'vant';
import su from '@/utils/server-utils'
import { Popup } from 'vant';
import { Icon } from 'vant';

//去ngix 配置 add_header Cache-Control 'no-cache, must-revalidate, proxy-revalidate, max-age=0';

const app = createApp(App)

app.use(Lazyload);
app.use(Popup);

app.use(pu)
app.use(su)

//挂载路由
app.use(router)

app.use(Vant)
app.use(Icon);

app.mount('#app')

Date.prototype.format = function(fmt)
{
    //author: meizz
    var o = {
        "M+" : this.getMonth()+1,
        "d+" : this.getDate(),
        "h+" : this.getHours(),
        "m+" : this.getMinutes(),
        "s+" : this.getSeconds(),
        "q+" : Math.floor((this.getMonth()+3)/3),
        "S"  : this.getMilliseconds()
    };
    if(/(y+)/.test(fmt))
        fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
    for(var k in o)
        if(new RegExp("("+ k +")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1)?(o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
}

export default app
